import { configureStore } from '@reduxjs/toolkit'
import dashboardSlice from '../Slices/DashboardSlice'
import attributesSlice from '../Slices/AttributesSlice'
import stopCodingSlice from '../Slices/StopCodingSlice'
import fileGallerySlice from '../Slices/FileGallerySlice'
import oiTreeSlice from '../Slices/OiTreeSlice'

export const store = configureStore({
    reducer: {
        dashboardSlice: dashboardSlice,
        attributesSlice: attributesSlice,
        stopCodingSlice: stopCodingSlice,
        fileGallerySlice: fileGallerySlice,
        oiTreeSlice: oiTreeSlice,
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store